import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import Particle from "../Particle";
import { FaExternalLinkAlt } from "react-icons/fa";

function Blogs() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          <strong className="purple">Tokenomics</strong>
        </h1>
        <p style={{ color: "white" }}>
          Detailed breakdown of BESC Coin's economic model and distribution
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={6} className="blog-card">
            <Card className="blog-card-view">
              <Card.Body>
                <Card.Title className="purple">Total Supply</Card.Title>
                <Card.Text style={{ textAlign: "left", color: "white" }}>
                  Fixed at 920,000 BESC Coins
                  <div style={{ marginTop: "20px" }}>
                    <strong>Contract Address:</strong><br />
                    <a 
                      href="https://solscan.io/token/DDE8MnEjYsukfiG2DCu4EeJM3wU4jngLci65mQyzYs7H"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: '#934cce', wordBreak: 'break-all' }}
                    >
                      DDE8MnEjYsukfiG2DCu4EeJM3wU4jngLci65mQyzYs7H{" "}
                      <FaExternalLinkAlt style={{ fontSize: '14px' }} />
                    </a>
                  </div>
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>

          <Col md={6} className="blog-card">
            <Card className="blog-card-view">
              <Card.Body>
                <Card.Title className="purple">Transaction Tax</Card.Title>
                <Card.Text style={{ textAlign: "left", color: "white" }}>
                  <ul>
                    <li>
                      <strong className="purple">Buy Tax:</strong> 0%
                    </li>
                    <li>
                      <strong className="purple">Sell Tax:</strong> 0%
                    </li>
                  </ul>
                  <p>
                   
                  </p>
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>

          <Col md={6} className="blog-card">
            <Card className="blog-card-view">
              <Card.Body>
                <Card.Title className="purple">Initial Allocation</Card.Title>
                <Card.Text style={{ textAlign: "left", color: "white" }}>
                  Distribution among:
                  <ul>
                    <li>Founders</li>
                    <li>Investors</li>
                    <li>Holders of V1 BESC LLC</li>
                  </ul>
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>

          <Col md={6} className="blog-card">
            <Card className="blog-card-view">
              <Card.Body>
                <Card.Title className="purple">Profit Allocation</Card.Title>
                <Card.Text style={{ textAlign: "left", color: "white" }}>
                  <ul>
                    <li>
                      <strong className="purple">30%:</strong> Reinvestment in equipment and business expansion
                    </li>
                    <li>
                      <strong className="purple">25%:</strong> Workforce development and training
                    </li>
                    <li>
                      <strong className="purple">30%:</strong> Marketing and customer engagement campaigns
                    </li>
                    <li>
                      <strong className="purple">15%:</strong> Blockchain infrastructure and operational improvements
                    </li>
                  </ul>
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>

          <Col md={6} className="blog-card">
            <Card className="blog-card-view">
              <Card.Body>
                <Card.Title className="purple">Revenue Streams</Card.Title>
                <Card.Text style={{ textAlign: "left", color: "white" }}>
                  <strong>Primary:</strong>
                  <ul>
                    <li>Construction services</li>
                    <li>Renovation projects</li>
                    <li>Snow plowing services</li>
                    <li>Centralized Exchange (Builders Exchange) Fees</li>
                  </ul>
                  <strong>Secondary:</strong>
                  <ul>
                    <li>Partnerships with subcontractors</li>
                    <li>Material suppliers adopting BESC Coin</li>
                  </ul>
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Blogs; 
